export const categoryDummyData = {
  id: "dummy",
  category_name_ch: "全部類別",
  category_name_en: "All",
};
